import React from 'react'
import {FooterLinkButton} from '@vio/atlas/Footer/FooterLinkButton'

import {Brand} from '@daedalus/core/src/brand/types'
import {checkIsCookieConsentEnabledForBrand} from '@daedalus/core/src/brand/utils'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

import {openCookiePreferencesCenter} from './utils'

interface Props {
  brand: Brand
}

export const CookiePreferencesLink = ({brand}: Props) => {
  const cookieConsentIsEnabled = checkIsCookieConsentEnabledForBrand(brand)

  return cookieConsentIsEnabled ? (
    <li>
      <FooterLinkButton onClick={openCookiePreferencesCenter}>
        <FormattedMessageWrapper
          dataId="CookiePreferences"
          id="cookies"
          defaultMessage="Cookies"
        />
      </FooterLinkButton>
    </li>
  ) : null
}
